var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDogecoin = function SvgDogecoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.398,
    cy: 12.335,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.912 4.336.324.008.3.016.162.012.258.023.18.02.187.023.29.044.2.035.205.04.208.045.105.025.213.054.216.06.217.067.11.036.22.077c.183.068.367.143.55.227l.22.105c1.977.983 3.821 3.015 3.821 7.21 0 3.725-1.47 5.695-3.122 6.732l-.195.118a6.827 6.827 0 0 1-.59.305l-.198.087-.196.079-.195.072-.194.066-.191.06-.19.054-.185.048-.092.022-.18.04-.177.036-.256.044-.164.025-.235.03-.149.015-.21.018-.252.014-.167.006-.204.001-.169-.004-.122-.005-5.45-.002v-7.122H4.898v-1.744h1.917V4.335h5.097Zm.11 2.954H9.879v4.167h3.375v1.745H9.878v4.167h2.327l.236-.005.267-.015.185-.018.201-.026.142-.023.147-.027.153-.032.077-.019.158-.041.161-.048a4.83 4.83 0 0 0 .246-.084l.165-.066.166-.073c1.188-.557 2.363-1.762 2.36-4.371-.004-2.64-1.172-3.954-2.376-4.603l-.168-.087a4.858 4.858 0 0 0-.252-.114l-.166-.067-.165-.06a5.235 5.235 0 0 0-.08-.026l-.161-.05a5.47 5.47 0 0 0-.079-.022l-.155-.04-.15-.035-.144-.03-.139-.024-.132-.02-.124-.017-.172-.017-.103-.008-.137-.008-.143-.003Z",
    fill: "#000"
  })));
};

export default SvgDogecoin;